module.exports = __webpack_public_path__ + "static/media/How to add or create potential client statuses.b446ea97.png";